import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { BaseForm } from 'uniforms';

var AntD = function AntD(parent) {
  var _ =
  /*#__PURE__*/
  function (_parent) {
    _inherits(_, _parent);

    function _() {
      _classCallCheck(this, _);

      return _possibleConstructorReturn(this, _getPrototypeOf(_).apply(this, arguments));
    }

    return _;
  }(parent);

  _.AntD = AntD;
  _.displayName = "AntD".concat(parent.displayName);
  return _;
};

export default AntD(BaseForm);